import React from "react";
import ListItem from "./ListItem";

const DataList = ({ data, clicked }) => {
  if (!data || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "60px 40px",
          color: "#666",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          margin: "0",
        }}
      >
        <h3 style={{ color: "#333", marginBottom: "10px", fontSize: "20px" }}>
          Nu au fost găsite rezultate
        </h3>
        <p style={{ fontSize: "14px", margin: 0, color: "#999" }}>
          Încercați să modificați criteriile de căutare sau verificați dacă
          există date disponibile
        </p>
      </div>
    );
  }

  const showCompanyColumn = data[0]?.proiect_id === 373;

  return (
    <div style={{ overflowX: "auto", margin: "20px 0" }}>
      <table
        className="table table-bordered table-hover"
        style={{
          minWidth: "800px",
          backgroundColor: "white",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <thead style={{ backgroundColor: "#343a40", color: "white" }}>
          <tr>
            <th
              style={{
                padding: "15px 12px",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              ID Client
            </th>
            <th
              style={{
                padding: "15px 12px",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              Proiect
            </th>
            {showCompanyColumn && (
              <th
                style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Nume firma
              </th>
            )}
            <th
              style={{
                padding: "15px 12px",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              Data si ora
            </th>
            <th
              style={{
                padding: "15px 12px",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              Status
            </th>
            <th
              style={{
                padding: "15px 12px",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              Telefon
            </th>
            <th
              style={{
                padding: "15px 12px",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              Actiuni
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((customer, index) => (
            <ListItem
              key={customer.id}
              data={customer}
              clicked={clicked}
              showCompanyColumn={showCompanyColumn}
              index={index}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataList;
